import type { FC } from 'react';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';

import CreateActionItemModal from './CreateActionItemModal';

interface CreateActionItemModalButtonProps {
  preselectCurrentSurvey?: boolean;
  onConfirm?: () => void;
  disabled?: boolean;
}

const CreateActionItemModalButton: FC<CreateActionItemModalButtonProps> = ({
  preselectCurrentSurvey,
  onConfirm,
  disabled = false,
}) => {
  const { t } = useTranslation('myFollowUp');
  const [open, setOpen] = useState(false);
  const handleCloseAfterConfirm = useCallback(() => {
    onConfirm?.();
    setOpen(false);
  }, [onConfirm]);

  return (
    <Box sx={{ flexShrink: 0 }}>
      <Button
        disabled={disabled}
        onClick={() => setOpen(true)}
        variant="cta"
        color="secondary"
      >
        {t('actionItem.create')}
      </Button>
      {open && (
        <CreateActionItemModal
          open={open}
          onClose={() => setOpen(false)}
          preselectCurrentSurvey={preselectCurrentSurvey}
          onConfirm={handleCloseAfterConfirm}
        />
      )}
    </Box>
  );
};

export default CreateActionItemModalButton;
